import Vue from 'vue';
import VueGtag from 'vue-gtag';

Vue.use(VueGtag, {
  config: {id: 'G-5G6Z0BJRQ4', params: {}},
  enabled: process.env.ENABLE_GA,
});
